"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Formula_1 = require("../Formula");
var Util_1 = require("../Util");
var ImplicationIndex = /** @class */ (function () {
    function ImplicationIndex(implications) {
        var _this = this;
        this.all = implications;
        this.byProperty = new Map();
        implications.forEach(function (i) {
            ImplicationIndex.properties(i).forEach(function (id) {
                if (!_this.byProperty.has(id)) {
                    _this.byProperty.set(id, new Set());
                }
                _this.byProperty.get(id).add(i);
            });
        });
    }
    ImplicationIndex.properties = function (implication) {
        return Util_1.union(Formula_1.properties(implication.when), Formula_1.properties(implication.then));
    };
    ImplicationIndex.prototype.withProperty = function (id) {
        return this.byProperty.get(id) || new Set();
    };
    return ImplicationIndex;
}());
exports.default = ImplicationIndex;
